import { resolvePendingDeviceLink } from '../deviceLink/deviceLinkDeepLink.ts'
import { navigate, shouldShowAddToHomeGuide } from '../ui/router.ts'

/** Dopo sblocco: deep link deviceLink ha priorità su home / addToHome. */
export function navigateAfterAuth(): void {
  const pending = resolvePendingDeviceLink()
  if (pending) {
    navigate('linkDeviceScan', { sessionId: pending })
    return
  }
  if (shouldShowAddToHomeGuide()) navigate('addToHome')
  else navigate('home')
}
